import React from 'react';
import './Form.css';

const Form = () => {
	return (
		<form action="https://formspree.io/masu.crta@gmail.com" method="POST">
			<div>
				If you like our work, or if you have any questions, please{' '}
				<span style={{ color: '#e30031' }}>send us an email</span>
				<p className={'form-dot'} />
			</div>
			<input type="text" name="name" placeholder="Your Name" />
			<input type="email" name="_replyto" placeholder="Your Email" />
			<input type="text" name="_gotcha" style={{ display: 'none' }} />
			<input type="hidden" name="_subject" value="New submission!" />
			<textarea name="message" cols="30" rows="5" placeholder="Your message" />
			<input type="submit" value="Send" />
		</form>
	);
};
export default Form;
